export default "__VITE_ASSET__DL7CMFu4__"